export default __webpack_public_path__ + "static/media/Map_Sodar_Gray.db7ac087.svg";